import { gql } from "@apollo/client";

const SYNC_PRODUCT_CATALOG = gql`
  mutation {
    syncProductCatalog {
      data
      status
      error
    }
  }
`;

export default SYNC_PRODUCT_CATALOG;
